export default __webpack_public_path__ + "static/media/enomos-logo.486cdd19.jpg";